import { STATUS_KEYS } from "../../schemas/status";

export const EXCLUDED_PRODUCT_STATUSES_FOR_NEW_BOOKING = [
    STATUS_KEYS.Sold,
    STATUS_KEYS.Reservation,
    STATUS_KEYS.FictionalReservation,
];
